import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import NavBar from "../NavBar";
import SideBar from "../SideBar";
import Footer from "../Footer";
import { getPathPrefix } from "../../utils/coreUtils";

function NavBarLayout() {
  const token = localStorage.getItem("authToken");

  if (!token) {
    return <Navigate to={getPathPrefix("login")} replace />;
  }

  return (
    <div>
      <NavBar />
      <SideBar />
      <div className="container-scroller">
        <div className="container-fluid page-body-wrapper p-0">
          <div className="main-panel list-geographical">
            <div className="content-wrapper">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NavBarLayout;
